import { useState, forwardRef, useImperativeHandle, useEffect } from 'react';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Form from 'react-bootstrap/Form';
import { getEtapas, getOrg } from '../../controllers/org';
import Loading from '../loading/Loading';
import { getRoles } from '../../controllers/roles';
import { profileTypes } from '../../controllers/profiles';
import { Button } from 'react-bootstrap';
import { useAuth } from '../auth/AuthProvider';
import { updateMembership } from '../../controllers/user';
import { Typeahead } from 'react-bootstrap-typeahead';

const toRadioValue = (value) => (value === true || value === 'true' ? 'true' : 'false');

const PerfilApostoladoForm = forwardRef((props, ref) => {
  const [org, setOrg] = useState();
  const [roles, setRoles] = useState();
  const [etapas, setEtapas] = useState();
  const [region, setRegion] = useState(props.apostolado?.region);
  const [diocesis, setDiocesis] = useState(props.apostolado?.diocesis);
  const [comunidad, setComunidad] = useState(props.apostolado?.comunidad);
  const [role, setRole] = useState(props.apostolado?.role);
  const [coordinadorEquipo, setCoordinadorEquipo] = useState(toRadioValue(props.apostolado?.coordinadorEquipo));
  const [apostoladoNacional, setApostoladoNacional] = useState(toRadioValue(props.apostolado?.apostoladoNacional));
  const [apostoladoComunidad, setApostoladoComunidad] = useState(toRadioValue(props.apostolado?.apostoladoComunidad));
  const [etapa, setEtapa] = useState(props.apostolado?.etapa);
  const [loading, setLoading] = useState(false);
  const { token } = useAuth();

  useEffect(() => {
    loadOrg();
    loadRoles();

    if (props.membresia.profileType === profileTypes.MATRIMONIO || props.membresia.profileType === profileTypes.MAMA) {
      loadEtapas();
    }
    
  }, [])

  useEffect(() => {
    if (!org) {
      return;
    }

    if (diocesis) {
      setRegion(org.diocesis.filter(d => d.diocesis_id === diocesis)[0].region_id);
      setComunidad(0);
    }
    else {
      setRegion(0);
      setComunidad(0);
    }
    console.log(`comunidad: ${comunidad}`);
    
  }, [diocesis])


  async function loadOrg(){
    if (!props.org) {
      let o = await getOrg();
      setOrg(o);
    }
    else {
      setOrg(props.org);
    }
  }

  async function loadRoles(){
    let r = await getRoles(props.membresia.profileType);
    setRoles(r);
  }
  async function loadEtapas(){
    let e = await getEtapas(props.membresia.profileType);
    setEtapas(e);
  }

  useImperativeHandle(ref, () => ({
    getApostolado() {
      return generateApostolado();
    },
    validate() {
      return validate();
    }
  }));

  function validate() {
    let missingFields = [];
    if (!region) {
      missingFields.push('región');
    }
    if (!diocesis) {
      missingFields.push('diócesis');
    }
    if (!comunidad) {
      missingFields.push('comunidad');
    }
    if (props.membresia.profileType !== profileTypes.ASESOR) {
      if (!apostoladoNacional) {
        missingFields.push('apostolado nacional');
      }
      else if (apostoladoNacional !== 'true' && !apostoladoComunidad) {
        missingFields.push('apostolado comunidad');
      }
      else if ((apostoladoNacional === 'true' || apostoladoComunidad === 'true') && !role) {
        missingFields.push('apostolado');
      }
      else if (!coordinadorEquipo) {
        missingFields.push('coordinador de equipo');
      }
      else if (apostoladoComunidad === 'false' && apostoladoNacional === 'false' && !etapa) {
        missingFields.push('etapa');
      }
    }
    
    if (missingFields.length) {
      return `Falta llenar la siguiente información: ${missingFields.join(', ')}`;
    }
  }

  function generateApostolado() {
    return {
      region,
      diocesis,
      comunidad,
      coordinadorEquipo: coordinadorEquipo === 'true',
      apostoladoNacional: apostoladoNacional === 'true',
      apostoladoComunidad: apostoladoComunidad === 'true',
      role,
      etapa: etapa ?? null
    };
  }

  async function submitUpdate() {
    let p = generateApostolado();
    p.ciclo = props.apostolado.ciclo;
    p.profileType = props.membresia.profileType;
    console.log(p);

    setLoading(true);
    try {
      let r = await updateMembership(token, props.userId, p);
      props.completedMembershipUpdate('editar-membresia');
    }
    catch (e) {
      props.completedMembershipUpdate('editar-membresia', e);
    }
    setLoading(false);
  }

  function renderSaveButton() {
    if (props.updateProfile) {
      return <Form.Group className="mb-3 submit-buttons-wrapper">
        <Button key='submit-btn-apostolado' type='submit' variant='primary' onClick={submitUpdate}>Actualizar apostolado</Button>
      </Form.Group>;
    }
  }

  function generateOptions(items, type){
    return items.map((it, idx) => {
      let id;
      switch (type) {
        case 'region': id = it.region_id; break;
        case 'diocesis': id = it.diocesis_id; break;
        case 'comunidad': id = it.comunidad_id; break;
      }
      return <option value={id} key={type + '-' + idx}>{it.label}</option>;
    });
  }

  function generateRoleOptions(){
    let options = [];

    if (apostoladoNacional === 'true') {
      options = roles.filter(r => r.level === 1 || r.level === 2 || r.level === 3);
    }
    else if (apostoladoComunidad === 'true') {
      options = roles.filter(r => r.level === 4);
    }

    return options.map((it, idx) => {
      return <option value={it.role_id} key={'roles-' + it.role_id}>{it.label}</option>;
    });
  }

  function generateEtapasOptions(){
    return etapas.map((it, idx) => {
      return <option value={it.etapa_id} key={'etapa-' + it.etapa_id}>{it.title}</option>;
    });
  }

  function renderSelectRole() {
    const showRoleSelector = apostoladoNacional === 'true' || apostoladoComunidad === 'true';

    if (showRoleSelector) {
      return <Form.Group className="mb-3">
        <Form.Label>Selecciona un apostolado</Form.Label>
        <Form.Select name='role' onChange={e => setRole(e.target.value === '' ? undefined : parseInt(e.target.value))} value={role ?? ''}>
          <option value="">-- Selecciona un apostolado --</option>
          {generateRoleOptions()}
        </Form.Select>
      </Form.Group>;
    }
  }
  function renderSelectEtapa() {
    if (etapas && (
      (apostoladoNacional === 'false' && apostoladoComunidad === 'false') ||
      (apostoladoNacional === 'false' && apostoladoComunidad === 'true' && coordinadorEquipo === 'true')
    )) {
      return <Form.Group className="mb-3">
        <Form.Label>Selecciona un nivel de formación</Form.Label>
        <Form.Select name='etapa' onChange={e => setEtapa(e.target.value === '' ? undefined : parseInt(e.target.value))} value={etapa ?? ''}>
          <option value="">-- Selecciona un nivel de formación --</option>
          {generateEtapasOptions()}
        </Form.Select>
      </Form.Group>
    }
  }

  if (!org || !roles) {
    return <Loading text='Cargando...'/>;
  }

  return <Row>
    <Col>
      <Form.Group className="mb-3">
        {/* <Typeahead
            id="type-diocesis"
            labelKey="label"
            onChange={(selected) => {
              console.log(selected);
              setDiocesis(selected);
            }}
            options={org.diocesis}
            placeholder="Selecciona la diócesis"
            renderMenuItemChildren={(option) => (
                <span>{option.label}</span>
            )}
            selected={diocesis}
          /> */}
        <Form.Label>Diócesis</Form.Label>
        <Form.Select name='diocesis' onChange={e => setDiocesis(parseInt(e.target.value))} value={diocesis}>
          <option value={0}>-- Selecciona una diócesis --</option>
          {generateOptions(org.diocesis, 'diocesis')}
        </Form.Select>
      </Form.Group>
      {!!diocesis && <Form.Group className="mb-3">
        <Form.Label>Comunidad</Form.Label>
        <Form.Select name='comunidad' onChange={e => setComunidad(e.target.value)} value={comunidad}>
          <option value={0}>-- Selecciona una comunidad --</option>
          {generateOptions(org.comunidades.filter(it => it.diocesis_id === diocesis), 'comunidad')}
        </Form.Select>
      </Form.Group>}

      { 
        props.membresia.profileType !== profileTypes.ASESOR &&
        <>
          <Form.Group className="mb-3">
            <Form.Label>¿Tienen un apostolado en el Equipo Coordinador Nacional, Región o Diócesis?</Form.Label>
            <Row>
              <Col md={2}>
                <Form.Check type="radio" name='apos-nacional' key='apos-nacional-no' className='mb-4' >
                  <Form.Check.Input id='apos-nacional-no' type="radio" name='apos-nacional' className='btn-check' value={false} onChange={e => { setRole(undefined); setApostoladoNacional(e.target.value); setApostoladoComunidad('false'); setCoordinadorEquipo('false'); }} checked={apostoladoNacional === 'false'} />
                  <Form.Check.Label htmlFor='apos-nacional-no' className='btn btn-dark p-3' >No</Form.Check.Label>
                </Form.Check>
              </Col>
              <Col md={2}>
                <Form.Check type="radio" name='apos-nacional' key='apos-nacional-si' className='mb-4' >
                  <Form.Check.Input id='apos-nacional-si' type="radio" name='apos-nacional' className='btn-check' value={true} onChange={e => { setRole(undefined); setApostoladoNacional(e.target.value); setApostoladoComunidad('false'); setCoordinadorEquipo('false'); }} checked={apostoladoNacional === 'true'}  />
                  <Form.Check.Label htmlFor='apos-nacional-si' className='btn btn-dark p-3' >Sí</Form.Check.Label>
                </Form.Check>
              </Col>
            </Row>
          </Form.Group>

          {apostoladoNacional === 'false' && 
          <>
            <Form.Group className="mb-3">
              <Form.Label>¿Tienen un apostolado el Equipo Coordinador de Comunidad?</Form.Label>
              <Row>
                <Col md={2}>
                  <Form.Check type="radio" name='apos-comunidad' key='apos-comunidad-no' className='mb-4' >
                    <Form.Check.Input id='apos-comunidad-no' type="radio" name='apos-comunidad' className='btn-check' value={false} onChange={e => { setRole(undefined); setEtapa(undefined); setApostoladoComunidad(e.target.value); setApostoladoNacional('false'); }} checked={apostoladoComunidad === 'false'} />
                    <Form.Check.Label htmlFor='apos-comunidad-no' className='btn btn-dark p-3' >No</Form.Check.Label>
                  </Form.Check>
                </Col>
                <Col md={2}>
                  <Form.Check type="radio" name='apos-comunidad' key='apos-comunidad-si' className='mb-4' >
                    <Form.Check.Input id='apos-comunidad-si' type="radio" name='apos-comunidad' className='btn-check' value={true} onChange={e => { setRole(undefined); setEtapa(undefined); setApostoladoComunidad(e.target.value); setApostoladoNacional('false'); }} checked={apostoladoComunidad === 'true'} />
                    <Form.Check.Label htmlFor='apos-comunidad-si' className='btn btn-dark p-3' >Sí</Form.Check.Label>
                  </Form.Check>
                </Col>
              </Row>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>¿Coordinan un equipo de formación?</Form.Label>
              <Row>
                <Col md={2}>
                  <Form.Check type="radio" name='apos-coord-equiop' key='apos-coord-equiop-no' className='mb-4' >
                    <Form.Check.Input id='apos-coord-equiop-no' type="radio" name='apos-coord-equiop' className='btn-check' value={false} onChange={e => { setCoordinadorEquipo(e.target.value); setEtapa(undefined); }} checked={coordinadorEquipo === 'false'} />
                    <Form.Check.Label htmlFor='apos-coord-equiop-no' className='btn btn-dark p-3' >No</Form.Check.Label>
                  </Form.Check>
                </Col>
                <Col md={2}>
                  <Form.Check type="radio" name='apos-coord-equiop' key='apos-coord-equiop-si' className='mb-4' >
                    <Form.Check.Input id='apos-coord-equiop-si' type="radio" name='apos-coord-equiop' className='btn-check' value={true} onChange={e => setCoordinadorEquipo(e.target.value)} checked={coordinadorEquipo === 'true'} />
                    <Form.Check.Label htmlFor='apos-coord-equiop-si' className='btn btn-dark p-3' >Sí</Form.Check.Label>
                  </Form.Check>
                </Col>
              </Row>
            </Form.Group>
          </>
          }

            { renderSelectRole() }

          { renderSelectEtapa() }
        </>
      }

      {renderSaveButton()}
    </Col>
  </Row>;
});

export default PerfilApostoladoForm;
